var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconClock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.486 0 0 4.48601 0 10C0 15.514 4.48595 20 10 20C15.514 20 20 15.514 20 10C20 4.48601 15.514 0 10 0ZM10 18.483C5.32249 18.483 1.51703 14.6775 1.51703 10C1.51703 5.32249 5.32249 1.51703 10 1.51703C14.6776 1.51703 18.483 5.32249 18.483 10C18.483 14.6775 14.6776 18.483 10 18.483Z",
    fill: "#FA114F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4898 10.377V5.47711H8.97278V11.1789L12.8821 13.843L13.7364 12.5893L10.4898 10.377Z",
    fill: "#FA114F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2745,
    cy: 13.1858,
    r: 0.758514,
    fill: "#FA114F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.73569,
    cy: 5.49951,
    r: 0.758514,
    fill: "#FA114F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Clock.c5f877c7.svg";
export { ForwardRef as ReactComponent };